<template>
  <div class="content">
    <div style="padding:15px;margin-bottom:0">
      <div class="title title-left">问答问题：</div>
      <div>
        <span class="ml10">{{ data.answer }}</span>
      </div>
      <div class="title title-left">资料：</div>
      <div class="name ml10">
        <div>
          姓名：<span>{{ data.name }}</span>
        </div>
        <div>
          性别：<span>{{ data && data.sex == 1 ? "男" : "女" }}</span>
        </div>
      </div>
      <div  class="ml10">
        出生年月日：<span>{{data.lunar == 1 ? '阴历' : '公历'}}{{ data.birthday }}</span>
      </div>
      <div class="ml10">
        出生时辰：<span>{{ data.time }}</span>
      </div>
      <div class="ml10" style="margin-bottom:0">
        随机数字：<span>{{ data.num }}</span>
      </div>
    </div>
    <div class="line" style="margin-bottom:0"></div>
    <div style="padding:15px">
      <div class="title title-left">老师解答：</div>
      <div>
        <!-- <span v-if="data.TeacherAnswerNum.length < 1 || (data.TeacherAnswer.length == 1 && data.TeacherAnswer[0].list.length == 0)">
          请耐心等待老师回复~  纯人工解答。</span> -->
        <template>
          <div v-for="(item,index) in data.TeacherAnswer" :key="index" style="margin-bottom:30px">
            <div style="display:flex; align-items: center;margin-bottom:10px">
              <img :src="item.tAvatar" class="img-h">
              <div style="margin-left:10px;margin-bottom:0">
                <p style="color:#333">{{item.tName}}</p>
                <p style="font-weight:normal">{{item.created_time}}</p>
              </div>
            </div>
            <div style="margin-left:1.1rem">
              <div v-for="(it,inx) in item.list" :key="inx">
                  <div v-html="it.content" style="font-weight:normal"></div>
                  <div v-if="inx == 0 && item.list.length > 1" style="color:#2fb1ad;margin-top:14px">补充回答</div>
              </div>
              <div v-if="item.list.length == 0" style="font-weight:normal">
                请耐心等待老师回复~  纯人工解答。
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
/**
@description:问答详情
@createTime:2021-09-01
@create:wq
*/

export default {
  name: "",
  props: {},
  components: {},
  data() {
    return {
      id: "",
      data: "",
    };
  },
  computed: {},
  watch: {},
  mounted() {},
  created() {
    if (this.$route.query && this.$route.query.id) {
      this.id = this.$route.query.id;
      this.myAnswerDetails();
    }
  },
  methods: {
    myAnswerDetails() {
      this.api.myAnswerDetails({ id: this.id }).then((res) => {
        this.data = res.data;
        console.log(res);
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.content {
  font-size: 0.3rem;
  font-weight: bold;
  color: #999999;
  // background: #F6F6F6;
  border-radius: 5px;
  // border: 1px solid #EFEFEF;
  // padding: 14px;
  span {
    color: #333333;
  }
  div {
    margin-bottom: 14px;
  }
}
.name {
  overflow: hidden;
  > div {
    float: left;
    margin-bottom: 0;
    margin-right: 14px;
  }
}
// .line{
//     width: 100%;
//     height: 1px;
//     background: #EFEFEF;
// }
.ml10{
  margin-left: 10px;
}
.title{
  color: #2fb1ad;
  display: flex;
  align-items: center;
}
.img-h{
  width: .9rem;
  height: .9rem;
  border-radius: 50%;
  object-fit: cover;
}
.t-content{
  display: flex;
  align-items: center;
  margin-bottom: .1rem !important;
}
.title-left {
  font-size: 0.32rem;
  font-weight: 400;
  color: #666666;
  display: flex;
  align-items: center;
  color: #2fb1ad;
  font-weight: bold;
  &::before{
    width: 4px;
    height: 16px;
    background: linear-gradient(180deg, #4fd9d5 0%, #2fb1ad 100%);
    opacity: 1;
    border-radius: 0px 4px 4px 0px;
    margin-right: 6px;
    content: '';
  }
}
.line {
  width: 100%;
  height: 1px;
  background: #efefef;
  height: .2rem;
}
</style>
